import React from 'react';
import { Link } from "react-router-dom";
import Container from 'react-bootstrap/Container';

function PageNotFound() {
  return (
    <Container className="text-center py-5">
      <div
        className="d-inline-flex align-items-center justify-content-center mb-3 rounded-circle"
        style={{
          width: 72,
          height: 72,
          background: 'var(--tp-surface-2)',
          color: 'var(--tp-muted)',
        }}
        aria-hidden="true"
      >
        <i className="fa-solid fa-compass fa-2x"></i>
      </div>
      <h2 className="text-danger">The requested page does not exist.</h2>
      <p className="text-body-secondary">
        The link may be broken, or the page may have moved.
      </p>
      <Link to="/" className="mt-2 d-inline-block">Go home</Link>
    </Container>
  );
}

export default PageNotFound;
